module.exports = __webpack_public_path__ + "img/Ellipse 95.36e38378.png";